import {onHashChange, onPopState} from '@acng/frontend-relativity/history';
import {main} from '../service/location.js';
import {update} from '../context/search-params.js';
import {toggleAll} from 'acng/layout/service/anchor-active.js';
import {closeAll} from 'acng/layout/service/auto-close.js';

/**
 * @param {import('acng/zz-app').RootScope} $rootScope
 */
export const runRouter = ($rootScope) => {
  $rootScope.request = main.globals;
  $rootScope.$on('$locationChangeSuccess', (_ev, newURL, oldURL, newState, oldState) => {
    update();
    DEBUG: main.VERBOSE && console.info('$LOCATIONCHANGE', {newURL, newState, oldState});
    if (!newState) {
      DEBUG: main.VERBOSE &&
        console.info('$LOCATIONCHANGE TRIGGERS relativity HASHCHANGE to polulate HISTORY STATE');
      onHashChange(new HashChangeEvent('hashchange', {newURL, oldURL}));
    } else if (newState !== oldState) {
      DEBUG: main.VERBOSE &&
        console.info('$LOCATIONCHANGE TRIGGERS relativity POPSTATE to keep the contexts sync');
      onPopState(new PopStateEvent('popstate', {state: newState}));
    }

    closeAll();
    toggleAll();
  });
};
